// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setFolderableOperation = createAction('[Folders] Set Folderable Operation', props());
